import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBagIcon, ArrowLeftIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { CartItem } from '../components/cart/CartItem';
import { CartSummary } from '../components/cart/CartSummary';
import { Button } from '../components/ui/Button';
export function CartPage() {
  const {
    items,
    itemCount
  } = useCart();
  const navigate = useNavigate();
  if (items.length === 0) {
    return <div className="min-h-screen bg-gray-50 py-12" data-id="element-1134" data-mp="25onjjuajon0m">
        <div className="max-w-7xl mx-auto px-4" data-id="element-1135" data-mp="25o4cx9qchl1w">
          <div className="text-center py-16" data-id="element-1136" data-mp="1rpnvanqy2a4z">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1137" data-mp="1roux4b61wsyg">
              <ShoppingBagIcon className="w-12 h-12 text-gray-400" data-id="element-1138" data-mp="1wqbvo012c3bv" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1139" data-mp="g8o4jwk8w3d2">
              Your cart is empty
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1140" data-mp="l6zhig5u6tzi">
              Looks like you haven't added any items to your cart yet.
            </p>
            <Link to="/products" data-id="element-1141" data-mp="196mjo8bcbweu">
              <Button variant="primary" size="lg" data-id="element-1142" data-mp="197nx2jftwuzq">
                Continue Shopping
              </Button>
            </Link>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 py-6" data-id="element-1143" data-mp="1j41047x9kl75">
      <div className="max-w-7xl mx-auto px-4" data-id="element-1144" data-mp="1j6di2l30uvk7">
        {/* Header */}
        <div className="flex items-center justify-between mb-6" data-id="element-1145" data-mp="1x2qw1k8cketx">
          <div data-id="element-1146" data-mp="1s5iffo2ukius">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-1147" data-mp="1s3xl9zkg31xg">
              Shopping Cart
            </h1>
            <p className="text-gray-600" data-id="element-1148" data-mp="26tbvtazrbpef">{itemCount} items in your cart</p>
          </div>
          <Link to="/products" className="flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium" data-id="element-1149" data-mp="21w386uvuat5s">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-1150" data-mp="2fut6ueyb50w9" />
            Continue Shopping
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1151" data-mp="2bqva2awgg26d">
          {/* Cart items */}
          <div className="lg:col-span-2" data-id="element-1152" data-mp="2iu1qwv7yuacm">
            <div className="bg-white rounded-xl shadow-card p-6" data-id="element-1153" data-mp="2nupsgattm9l3">
              {items.map(item => <CartItem key={item.product.id} item={item} data-id="element-1154" data-mp="2sulwub6fk316" />)}
            </div>
          </div>

          {/* Order summary */}
          <div className="lg:col-span-1" data-id="element-1155" data-mp="2xm3xey4jk1lm">
            <div className="sticky top-32" data-id="element-1156" data-mp="2xn5at991506i">
              <CartSummary onCheckout={() => navigate('/checkout')} data-id="element-1157" data-mp="31nfe2e5ftcho" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}